(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["senstide-collab-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('senstide-collab-gallery')) {
  customElements.define('senstide-collab-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-st-track]');
      this.slides = Array.from(this.querySelectorAll('[data-st-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-st-dot]'));
      this.index = 0;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.querySelector('[data-st-prev]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-st-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), options));
      this.track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, options);
      this.track.addEventListener('scroll', () => {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {...options, passive: true});
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-st-slide]');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.show(index, false);
      }, options);
      this.resize = new ResizeObserver(() => this.show(this.index, false));
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
    show(index, smooth = true) {
      if (!this.slides.length) return;
      const next = (index + this.slides.length) % this.slides.length;
      this.index = next;
      this.track.scrollTo({left: next * this.track.clientWidth, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant'});
      this.updateControls();
    }
    update() {
      if (!this.track.clientWidth) return;
      this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / this.track.clientWidth)));
      this.updateControls();
    }
    updateControls() {
      this.dots.forEach((dot, index) => {
        if (index === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const status = this.querySelector('[data-st-status]');
      if (status) status.textContent = (this.index + 1) + ' / ' + this.slides.length;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["senstide-feature-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('senstide-feature-video')) {
  customElements.define('senstide-feature-video', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.visible = false;
      this.automatic = this.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.automatic) this.video.controls = true;
      this.abort = new AbortController();
      this.loadObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.prepare();
          this.loadObserver.disconnect();
        }
      }, {rootMargin:'300px 0px'});
      this.loadObserver.observe(this);
      this.playObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        if (this.visible) {
          this.prepare();
          if (this.automatic && !document.hidden) this.play();
        } else {
          this.video.pause();
        }
      }, {threshold:[0,0.15]});
      this.playObserver.observe(this);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else if (this.visible && this.automatic) this.play();
      }, {signal:this.abort.signal});
    }
    prepare() {
      if (this.video.hasAttribute('src')) return;
      this.video.src = this.video.dataset.videoSrc;
      this.video.load();
    }
    play() {
      const promise = this.video.play();
      promise?.catch(() => { this.video.controls = true; });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.loadObserver?.disconnect();
      this.playObserver?.disconnect();
      this.video?.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
